<template>
  <div class="footer-wrapper">
    <div class="footer-block">
      <!-- <p>Copyright© 2016-2020. All rights reserved.{{allOrder.Name}}有限公司</p> -->
      <p>{{allOrder}}有限公司</p>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <!-- Copyright© 2016-2020. All rights reserved. 集運世家有限公司 -->
      <!-- <p>
                全球服務熱線：<span style="font-weight: bold;">00852-31158366</span>  周一至周日09:00-18:00
                <br>
                <span span style="font-weight: bold;">00852-31158399  +8619926638591</span>
            </p> -->
      <p>
        <a href="http://www.rcominfo.com" style="color: #fff"
          >集运系统由深圳瑞康软件定制开发</a
        >
      </p>
     <!-- <ul class="footer">
        <li>聯系我們</li>
        <li>聯系電話：68383111</li>
        <li>傳真號碼：</li>
        <li>詳細地址：廣東省東莞市虎門鎮沙角社區濱海大道虎門段155號103室</li>
      </ul> -->
      <!-- <div>{{allOrder}}</div> -->
    </div>
  </div>
</template>
<script>
let Base64 = require("js-base64").Base64;
import axios from "axios";
import md5 from "js-md5";
export default {
  data() {
    return {
      allOrder: localStorage.getItem("shopName"),
    };
  },
};
</script>
<style lang="scss" scoped>
.footer-wrapper {
  @include backgroundColor($_color);
  width: 100%;
  height: 100px;
  .footer-block {
    display: flex;
    height: 100px;
    justify-content: center;
    margin: 0 auto;
    align-items: center;
    color: #fff;
    //    p{
    //     font-size: 14px;
    //     cursor: pointer;
    //    }
    //    p:nth-child(2){
    //     width: 355px;
    //     position: relative;
    //     left: 200px;
    //    }
    .footer {
      position: relative;
      left: 200px;
      li {
        padding: 2px 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/layout/footer/index.vue